module.exports = __webpack_public_path__ + "media/images/lp/ashinaga-aai/home/home-cs-items-box-image-354b0b4e326d6a539d79f1df66ef2e56.jpg";